export default __webpack_public_path__ + "static/media/AbrahamSimpson.7c7e4520.png";